import { render, staticRenderFns } from "./myStat.vue?vue&type=template&id=d8cb39b6&"
import script from "./myStat.vue?vue&type=script&lang=js&"
export * from "./myStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports